import View from './view';

export const RootMobileTitle = View;
